module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2023_05.5d9952dc.webp";